export const TITLE = {
  first: 'Choose eligible products',
  second: 'Set your storefront widget toggle status',
  third: 'Pick go-live date',
  forth: 'Review and finish',
};
export const DESC = {
  first: 'Return Assurance will apply to the items that your selected. ',
  second: 'This is how the widget will look like in your storefront.',
  third: 'This is when the product will go live in your store.',
  forth: '',
};

export const ELIGIBLE_PRODUCTS_LIST = [
  {
    value: '1',
    label: 'All products (Automated)',
    recommended: 'Recommended',
    desc: 'Your customers can purchase Return Assurance for any product in your store.',
  },
  {
    value: '2',
    label: 'Selected products',
    desc: 'Return Assurance will only be available for selected products specified by you.',
  },
];
export const CODITION_MATCH_TYPE = [
  {
    value: '1',
    label: 'All conditions',
  },
  {
    value: '2',
    label: 'Any conditions',
  },
];
export const CONDITION_SELECT = [
  {
    value: '1', label: 'Collection', disabled: true,
  }, {
    value: '2', label: 'Discount',
  }, {
    value: '3', label: 'Product tag',
  },
];

export const CONDITION_MAP = {
  1: 'is in',
  2: '≥',
  3: 'is',
};

export const WIDGET_STATUS_LIST = [
  {
    value: '1',
    label: 'Default On',
    recommended: 'Recommended',
    desc: 'Return Option will be On by default. Buyers can choose to opt-out.',
  },
  {
    value: '2',
    label: 'Default Off',
    desc: 'Return Option will be Off by default. Buyers can choose to opt-in.',
  },
];
